import React from 'react';
import './App.css';
import logo from './icn-popcorn-chrome-128.png';
import axios from 'axios';
import GoogleLogin from 'react-google-login';
import ReactGA from 'react-ga';
import YouTube from 'react-youtube';
const { DateTime } = require("luxon");
const queryString = require('query-string');
const parsed = queryString.parse(window.location.search);
console.log(parsed)
let lambdaUrl = "https://jsy47z9vfi.execute-api.us-east-1.amazonaws.com/default/DiscussionBar_Elastic";
let follow = "";
let sub_path=""
let hr = window.location.href;
let i = hr.lastIndexOf("/");
let j = hr.lastIndexOf(".com/");
var referral_type="web";
var do_invite=false;
var signup_browser="";
var signup_mobile=false;
var party_id="";
var party_record = {};
var user={};
var retry=100;
var new_user = false;
var this_self;
var prettySite = {"youtube": "YouTube", "netflix": "Netflix", "disney":"Disney+"};
axios.defaults.headers.post['Content-Type'] ='application/x-www-form-urlencoded';
ReactGA.initialize('UA-142207592-2');
ReactGA.pageview(window.location.pathname + window.location.search);
if (i>(j+4)) {
  sub_path = hr.substring(
    j+ 5, 
    i
);
} else {
  if (!(hr.includes('?')) && hr.length>(j+4)) {
    sub_path = hr.substring(
      j+ 5);
  }
}
if (j===0) {
  sub_path = "";
}

try {
  // Opera 8.0+
var isOpera =(!!window.opr) || !!window.opera || navigator.userAgent.indexOf(' OPR/') >= 0;;
    // Firefox 1.0+
  var isFirefox = typeof InstallTrigger !== 'undefined';

  // Safari 3.0+ "[object HTMLElementConstructor]" 
  var isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
  navigator.userAgent &&
  navigator.userAgent.indexOf('CriOS') == -1 &&
  navigator.userAgent.indexOf('FxiOS') == -1;

  // Internet Explorer 6-11
  var isIE = /*@cc_on!@*/false || !!document.documentMode;

  // Edge 20+
  var isEdge = !isIE && !!window.StyleMedia;

  // Chrome 1 - 79
  var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

  // Edge (based on chromium) detection
  var isEdgeChromium = isChrome && (navigator.userAgent.indexOf("Edg") != -1);

  if (isOpera) {
    signup_browser =  'Opera';
  }
  if (isFirefox) {
    signup_browser = 'Firefox';
  }
  if (isChrome) {
    signup_browser = 'Chrome';
  }
  if (isSafari) {
    signup_browser = 'Safari';
  }
  if (isIE) {
    signup_browser = 'IE';
  }
  if (isEdge) {
    signup_browser = 'Edge';
  }
  if (isEdgeChromium) {
    signup_browser = 'EdgeChromium';
  }
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) signup_mobile = true;})(navigator.userAgent||navigator.vendor||window.opera);
} catch (e) {

}

var isProspect = ((signup_browser === 'Chrome') && !signup_mobile);
var useValue=0;
var prospect = "wrongspecs";
if (isProspect) {
  useValue=1;
  prospect = "chromedesktop";
}

function simpleUser(user) {
  var new_user = {};
  if (!('_id' in user)) {
      return new_user;        
  }
 // new_user.id = user.id;
  new_user._id = user._id;
//  new_user.family_name = user.family_name;
 // new_user.given_name = user.given_name;
  new_user.name = user.name;
 // new_user.locale = user.locale;
  new_user.date = user.date;
  new_user.picture = user.picture;
  return new_user;
}

function addInvite1() {
  let d = new Date();
  let invite = {type: "channel", id: party_id, user: simpleUser(user), name: party_record._source.name, channel_type: 'party', status: "joined_received", date: d};
  let to_post = {userId: party_record._source.user._id, currentUserId: user._id, invite: invite, channel: "", friend_id: user._id, friend_add: true};
  axios.post(lambdaUrl+"?action=add_invite",to_post)
  .then(res => {   
    retry = 100;
    changeMember1();
  }).catch((error) => {
    if (retry<=0) {
      retry = 100;
      alert('Error responding')
    } else {
      retry -= 1;
      addInvite1();     
    }
  })
}

function partyEmail() {
  let party_data = party_record._source;
  let dt = DateTime.fromISO(party_record._source.party_time);
  let site = prettySite[party_record._source.site];
  var s_link="";
  retry=0;
  if (party_data.content_id>"") {
    if (party_data.site === "youtube") {
        s_link= "http://www.youtube.com/watch?v="+party_data.content_id+"&db_party="+party_record._id;
    } else if (party_data.site === "netflix") {
      s_link=  "https://netflix.com/watch/"+party_data.content_id+"?db_party="+party_record._id;
    } else if (party_data.site === "disney") {
      s_link=  "https://disneyplus.com/video/"+party_data.content_id+"?db_party="+party_record._id;
    } 
  } else {
      if (party_data.site === "youtube") {
        s_link= "http://www.youtube.com/?db_party="+party_record._id;
    } else if (party_data.site === "netflix") {
      s_link=  "https://netflix.com/?db_party="+party_record._id;
    } else if (party_data.site === "disney") {
      s_link=  "https://disneyplus.com/?db_party="+party_record._id;
    } 
  }
  let to_post = {email: user.email, name: user.name, party_host: party_record._source.user.name, site: site, party_name: party_record._source.name,party_time: dt.toLocaleString(DateTime.DATETIME_FULL), party_description: party_record._source.description, party_link: s_link};
  fetch(lambdaUrl+"?action=party_email_popcorn", {
    method: 'post',
    body: JSON.stringify(to_post)})
    .then(function(response) {
      if (new_user) {
   //     alert("Congratulations!!! Your Popcorn account has been created. You will now be taken to the free installation page.");
        alert("Congratulations!!! You will now be taken to the free Popcorn installation page.");  
        window.location.href = "http://bit.ly/discussionbar";
      } else {
        this_self.setState({success: true});
      }
    })
    .catch(function (error) {
      if (retry<=0) {
        retry = 100;
        alert('Error responding')
      } else {
        retry -= 1;
        partyEmail();     
      }
    })
  }
    
/*
  axios.post(lambdaUrl+"?action=party_email",to_post)
  .then(res => {   
    if (new_user) {
      alert("Congratulations!!! Your DiscussionBar account has been created. You will now be taken to the free installation page.");

      window.location.href = "http://bit.ly/discussionbar";
    } else {
      window.location.href =window.location.pathname + window.location.search+"&success";
    }
  }).catch((error) => {
    console.log(error)
    if (retry<=0) {
      retry = 100;
      alert('Error responding')
    } else {
      retry -= 1;
      partyEmail();     
    } 
  }) 
} */

function addInvite2() {
  let d = new Date();
  let invite = {type: "friend", id: user._id, user: simpleUser(user), status: "accept_received", date: d};
  let to_post = {userId: follow, currentUserId: user._id, invite: invite, channel: "", friend_id: user._id, friend_add: true};
  axios.post(lambdaUrl+"?action=add_invite",to_post)
  .then(res => {   
    alert("Congratulations!!! Your Popcorn account has been created. You will now be taken to the free installation page.");

    window.location.href = "http://bit.ly/discussionbar";
  }).catch((error) => {
    if (retry<=0) {
      retry = 100;
      alert('Error responding')
    } else {
      retry -= 1;
      addInvite2();     
    }
  })
}

function addMyInvite() {
  let d = new Date();
  let invite = {type: "channel", id: party_id, user: simpleUser(user), name: party_record._source.name.toUpperCase(), channel_type: 'party', status: "joined_sent", date: d};
  let to_post = {userId: user._id, currentUserId: user._id, invite: invite, channel: party_id, friend_add: true, friend_id: party_record._source.user._id, channel_add: true, add_email: 'party_'+party_id};
  axios.post(lambdaUrl+"?action=add_invite",to_post)
  .then(res => {   
    retry = 100;
    addInvite1();
  }).catch((error) => {
    if (retry<=0) {
      retry = 100;
      alert('Error responding')
    } else {
      retry -= 1;
      addMyInvite();     
    }
  })
}

function addChannel() {
  let d = new Date();
  let to_post = {userId: user._id, currentUserId: user._id, simple_user: simpleUser(user), channel: party_id,gId:user.id};
  axios.post(lambdaUrl+"?action=add_channel",to_post)
  .then(res => {   
    retry = 100;
    partyEmail();
  //  alert("Congratulations!!! You will now be taken to the free Popcorn installation page.");

    window.location.href = "http://bit.ly/discussionbar";
  }).catch((error) => {
    if (retry<=0) {
      retry = 100;
      alert('Error responding')
    } else {
      retry -= 1;
      addChannel();     
    }
  })
}

function addFollowAlert() {
  let d = new Date();
  let to_post = {userId: user._id, currentUserId: user._id, simple_user: simpleUser(user), following: user.following, follow: follow, gId:user.id};
  axios.post(lambdaUrl+"?action=addFollowAlert",to_post)
  .then(res => {   
    retry = 100;
    if (party_id>"" && !user.channels.includes(party_id)) {
      addChannel();
    } else {
      alert("Congratulations!!! You will now be taken to the free Popcorn installation page.");

      window.location.href = "http://bit.ly/discussionbar";
    }

  }).catch((error) => {
    if (retry<=0) {
      retry = 100;
      alert('Error responding')
    } else {
      retry -= 1;
      addFollowAlert();     
    }
  })
}

function changeMember1() {
  let to_post = {userId: user.id, user_id: user._id, id: party_id, add: true};
  axios.post(lambdaUrl+"?action=changeChannelMember",to_post).then(res => {   
    partyEmail();
  }).catch((error) => {
    if (!retry) {
      retry = 100;
      alert('Error responding')
    } else {
      retry -= 1;
      changeMember1();     
    }
  })
}
function responseGoogle (response) {
  this_self.setState({logging_in: true});
  let profile = {};
  if ('profileObj' in response) {
    profile = response.profileObj;
    profile.referral = referral_type;
    profile.signup_browser=signup_browser;
    profile.signup_mobile=signup_mobile;
    profile.party_id = party_id;
    if (follow > "") {
      profile.follow = follow;
    }
    axios.post(lambdaUrl+"?action=login_follow", profile)
    .then(res => {
      let x = res.data.body.hits.total.value; 
      if (x >= 1) {
     //   alert("You already have a DiscussionBar account. You will now be taken to the installation page.");
        user = res.data.body.hits.hits[0]._source;
        user._id = res.data.body.hits.hits[0]._id;
        ReactGA.pageview(window.location.pathname +'?account_found&signup_browser='+signup_browser+"&signup_mobile="+signup_mobile);
        ReactGA.event({
          category: 'User',
          action: 'found_'+prospect,
          value: useValue
        });
        if (follow=="" && party_id=="") {
          window.location.href = "http://bit.ly/discussionbar";
        }
        console.log(user);
        if (follow>"" && !(user.following.includes(follow))) {
          addFollowAlert();
        } else if (party_id>"" && !user.channels.includes(party_id) ) {
          addChannel();
        } else {
          window.location.href = "http://bit.ly/discussionbar";
        }
        /*
        if (party_id>"") {
          if (user.channels.includes(party_id)) {
            this_self.setState({success: true, reshow: true});
            return;
          } else {
            addFollowAlert();  
          }   
        } else {
          window.location.href = "http://bit.ly/discussionbar";
        } */
    //   this.setState({ show_have: true });
      } else {
        axios.post(lambdaUrl+"?action=addFollowUser", profile)
        .then(res => {
          new_user = true;
          user = res.data;
          ReactGA.pageview(window.location.pathname +'?account_created'+"&signup_browser="+signup_browser+"&signup_mobile="+signup_mobile);
          ReactGA.event({
            category: 'User',
            action: 'create_'+prospect,
            value: useValue
          });
          addFollowAlert();
        })
      }
    })
  } else {
    ReactGA.event({
      category: 'User',
      action: 'failedlogin_'+prospect,
      value: useValue
    });
    this_self.setState({logging_in: false});
  }
}

class App extends React.Component {
  constructor(props) {

    super(props);
    this.state = {email: "", name: "", loading: true, description: "", party_name: "", party_info: "", link: "", youdisplay: "none",
    opts: {
      height: "315px",
      width: "560px",
    }, 
    button: "Get Popcorn for Free",logging_in: false,success: false, reshow: false};
    this_self = this;  
  }
  
  componentDidMount() {
      ReactGA.event({
        category: 'Display',
        action: prospect,
        value: useValue
      });

      if ('follow' in parsed) {
        follow = parsed.follow;
        referral_type = "follow";
      } 
      if ('party' in parsed) {
        party_id = parsed.party;
      }
      do_invite = ('invite' in parsed);
      if (party_id !== "") {
        axios.get(lambdaUrl+"?action=get_party&party="+party_id)
        .then(res => {
          party_record = res.data.hits.hits[0];
          let party_data = res.data.hits.hits[0]._source;
          let desc = "";
          desc = "Watch " + party_data.name + " with " + party_data.user.name;
          let dt = DateTime.fromISO(party_data.party_time);
          let site = prettySite[party_data.site];
          var s_link="";
          if (party_data.content_id>"") {
            if (party_data.site === "youtube") {
                s_link= "http://www.youtube.com/watch?v="+party_data.content_id+"&db_party="+res.data.hits.hits[0]._id;
            } else if (party_data.site === "netflix") {
              s_link=  "https://netflix.com/watch/"+party_data.content_id+"?db_party="+res.data.hits.hits[0]._id;
            } else if (party_data.site === "disney") {
              s_link=  "https://disneyplus.com/video/"+party_data.content_id+"?db_party="+res.data.hits.hits[0]._id;
            } 
          } else {
            if (party_data.site === "youtube") {
                s_link= "http://www.youtube.com/?db_party="+res.data.hits.hits[0]._id;
            } else if (party_data.site === "netflix") {
              s_link=  "https://netflix.com/?db_party="+res.data.hits.hits[0]._id;
            } else if (party_data.site === "disney") {
              s_link=  "https://disneyplus.com/?db_party="+res.data.hits.hits[0]._id;
            } 
          }
          this.setState({description: desc, name: party_data.user.name, party_name: party_data.name, loading: false, link: s_link, party_info: dt.toLocaleString(DateTime.DATETIME_FULL)+ " on "+site, button: "Watch with "+party_data.user.name});
      });
      } else if (follow !== "") {
        axios.get(lambdaUrl+"?action=get_follow&follow="+follow)
        .then(res => {
          let follow_data = res.data.hits.hits[0]._source;
          let desc = "";
          desc = "Watch YouTube, Netflix and Disney+ With " + follow_data.name;
          this.setState({description: desc, loading: false});
      });
      } else {
        this.setState({loading: false});
      }
      this.updateDimensions();
      window.addEventListener("resize", this.updateDimensions.bind(this));
  }
  
  updateDimensions () {
    let r = document.getElementById('divSecond').getClientRects();
    this.setState({ opts: {height: r[0].height+"px", width: "100%"}, youdisplay: "none" });
    var self = this;
    setTimeout(function(){self.setState({youdisplay: "block" })},1000);
   }
 
  render() {
    const opts = {
      height: 315,
      width: 560,
      playerVars: {
        // https://developers.google.com/youtube/player_parameters
        autoplay: 0
      },
    };

  return (
      <div className="App">
        <header className="App-header">
          <div className="topDiv">
          <span className="topTitle"><img src={logo} height="48"></img><span style={{marginLeft: "10px", verticalAlign: "super"}}>Join Popcorn</span></span>
              <span className="topButton">
              <GoogleLogin
    clientId="281219611151-m2a1d3jpckd1gg3aue0cdg4mmmjbv89o.apps.googleusercontent.com"
    buttonText={this.state.button}
    onSuccess={responseGoogle}
    onFailure={responseGoogle}
    className="free-button"
    icon={false}
    cookiePolicy={'single_host_origin'}
  />
              </span>
          </div>
          <div className="first-half">
          <div className="innerFirst">
        <h1 className="stream">Streaming Made Social</h1>      
        <div>
        <ul className="ul-db">
        {this.state.party_name ? <li>Watch <span style={{fontStyle: "italic", fontWeight: "bold", fontSize: "20px", color: "black", fontFamily: "auto"}}>{this.state.party_name}</span> with {this.state.name}</li> : this.state.description ? <li className="friend">{this.state.description}</li>  : <li className="friend">Watch and sync videos while chatting with your friends.</li>}
        {this.state.party_info ? <li>{this.state.party_info}</li>: <span></span>}
        { this.state.success ? this.state.reshow ?<li>You are already set to join.
        You can watch with {this.state.name} by <a style={{color: "black"}} href={this.state.link}>clicking here</a> at the watch party time.</li>: <li>Thanks!!! You can watch with {this.state.name} by <a style={{color: "black"}} href={this.state.link}>clicking here</a> at the watch party time. The link will also be e-mailed to you for later reference.</li> :
<li>Popcorn is a Chrome extension for YouTube, Netflix and Disney+ that allows users & creators to watch, chat and sync videos for a party like atmosphere. Like having your friends over for movie night.</li>}

{ this.state.success ?  <span></span>: <li>With Popcorn you don't need to pre-plan the party.  Simply go to YouTube, Netflix or Disney+ and you can see what your friends are watching and join them. Popcorn is a full social platform. You control who your friends are and what you share.</li>}

{ this.state.success ?  <span></span> : this.state.party_info ? <li>Login With Google To Let {this.state.name} Know You Will Attend. Join the fun!!!</li>:
<li>Login With Google To Create Your Popcorn Account via the Chrome Store. Join the fun!!!</li>}

{ this.state.success ?  <span></span> :
this.state.logging_in ? <li>Processing...</li> :
    <li><GoogleLogin
    clientId="281219611151-m2a1d3jpckd1gg3aue0cdg4mmmjbv89o.apps.googleusercontent.com"
    buttonText={this.state.button}
    onSuccess={responseGoogle}
    onFailure={responseGoogle}
    className="free-button"
    icon={false}
    cookiePolicy={'single_host_origin'}
  /></li> }
    {this.state.success ? <li><a href="https://chrome.google.com/webstore/detail/discussionbar/aodnjklklbdjdlidmebhhkpealnafege">If you have not yet installed Popcorn you can do so by clicking here</a></li> :
<li>
<div style={{fontSize: "13px", "marginTop": "15px"}}>* Available on Chrome browsers on desktop or laptop computers</div>
      <div className="div-link"><a href="https://chrome.google.com/webstore/detail/discussionbar/aodnjklklbdjdlidmebhhkpealnafege">If you are unable to Login to Google you can install Popcorn directly by clicking here</a></div></li> }
      <li><div style={{marginTop: "10px",height: "100px"}}><img height={80} className="center-element" src="logos.png"></img></div></li>
        </ul>
        </div>

            </div>
        </div>
 <div className="second-half">
 <div id="divSecond" className="innerSecond">
 <YouTube videoId="Bt_XAPBXr5M" opts={this.state.opts} onPlay={this._onPlay}/></div>
 </div>
        </header>
      </div>
  )
}
updateInputValue(evt) {
  this.setState({
    email: evt.target.value
  });
};

_onPlay(event) {
  // access to player in all event handlers via event.target
  ReactGA.event({
    category: 'Video',
    action: 'play_'+prospect,
    value: useValue
  });
}
};

export default App;
